<template>
  <div>
    <!-- <section class="inner_banner"></section> -->

    <section class="exchange_wrapp">
      <div class="container">
        <article class="row justify-content-center">
          <aside class="col-md-5">
            <div class="banner_right_box">
              <h4>Choose Which Assets to switch</h4>
              <div class="quantity">
                <div class="form-group">
                  <label for="quantity">Quantity: </label>
                  <input
                    type="number"
                    class="form-control"
                    v-model="swapAmount"
                    @input="calculateFeeAndEnableSwapBtn"
                    @change="calculateFeeAndEnableSwapBtn"
                  />
                </div>
              </div>
              <div class="cc-selector">
                <h5>Deposit</h5>
                <span v-for="(item, index) in tokenList" :key="item.name">
                  <input
                    :id="'selector' + (index + 1)"
                    type="radio"
                    name="currancy"
                    :value="'selector' + (index + 1)"
                    :checked="depositSelection == index"
                  />
                  <label
                    :class="'drinkcard-cc ' + 'icon' + (index + 1)"
                    :for="'selector' + (index + 1)"
                    @click="flipTokenInTokenOut('deposit', index)"
                  ></label>
                </span>
                <!-- <input id="selector3" type="radio" name="currancy" value="selector3"/>
                                <label class="drinkcard-cc icon3" for="selector3"></label>
                                <input id="selector4" type="radio" name="currancy" value="selector4"/>
                                <label class="drinkcard-cc icon4" for="selector4"></label> -->
              </div>
              <div class="cc-selector">
                <h5>Receive</h5>
                <span v-for="(item, index) in tokenList" :key="item.name">
                  <input
                    :id="'receive' + (index + 1)"
                    type="radio"
                    name="currancy2"
                    :value="'receive' + (index + 1)"
                    :checked="receiveSelection == index"
                  />
                  <label
                    :class="'drinkcard-cc ' + 'icon' + (index + 1)"
                    :for="'receive' + (index + 1)"
                    @click="flipTokenInTokenOut('receive', index)"
                  ></label>
                </span>
                <!-- <input id="selector7" type="radio" name="currancy2" value="selector7"/>
                                <label class="drinkcard-cc icon3" for="selector7"></label>
                                <input id="selector8" type="radio" name="currancy2" value="selector8"/>
                                <label class="drinkcard-cc icon4" for="selector8"></label> -->
              </div>

              <aside class="col-md-12">
                <div class="fees_table" style="box-shadow: none">
                  <div class="table-responsive">
                    <table>
                      <tbody>
                        <tr>
                          <th>
                            {{ tokenList[depositSelection].name }} Balance:
                          </th>
                          <td>
                            {{ tokenAUserBalance }}
                          </td>
                        </tr>
                        <tr>
                          <th>
                            {{ tokenList[receiveSelection].name }} Balance:
                          </th>
                          <td>
                            {{ tokenBUserBalance }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </aside>
            </div>
            <div class="wallet_address">
              <h4 v-if="account">Wallet address</h4>
              <div v-if="account" class="form-group">
                <!-- <input
                  type="text"
                  class="form-control"
                  v-model="recipientAddress"
                  @input="setSwapBtnDisabledStatus"
                  @change="setSwapBtnDisabledStatus"
                  placeholder="Enter your ETH recipient address"
                /> -->
                <h6 style="overflow-wrap: break-word">{{ account }}</h6>
              </div>
              <div class="form-group">
                <input
                  type="checkbox"
                  id="fruit1"
                  name="fruit-1"
                  v-model="isTermAccepted"
                  @change="setSwapBtnDisabledStatus"
                />
                <label for="fruit1"
                  >I agree with Terms of Use, Privacy Policy</label
                >
              </div>
              <span
                v-if="
                  account &&
                  !(
                    Number(this.swapAmount) != 0 &&
                    Number(this.swapAmount) <= Number(this.tokenAUserBalance)
                  )
                "
                style="color: red"
                >* Insufficient
                {{ tokenList[depositSelection].name }} Balance</span
              >
              <div class="exchange_button">
                <b-button
                  size="lg"
                  class="btn_blue"
                  :disabled="isSwapBtnDisabled"
                  @click="swap()"
                >
                  Switch Now
                </b-button>
              </div>
            </div>
          </aside>
          <aside class="col-md-5">
            <div class="fees_table">
              <div class="table-responsive">
                <table>
                  <tbody>
                    <tr>
                      <th>Total trade amount</th>
                      <td>{{ swapAmount | formatNum }}</td>
                    </tr>
                    <tr>
                      <th>Pool fees</th>
                      <td>${{ swapFee | toEth }}</td>
                    </tr>
                    <tr>
                      <th>Send total</th>
                      <td>{{ swapTotal | toTokens | formatNum }}</td>
                    </tr>
                    <tr>
                      <th>Receive total</th>
                      <td>{{ swapAmount | formatNum }}</td>
                    </tr>
                    <tr>
                      <th>{{ tokenList[depositSelection].name }} Before</th>
                      <td>
                        <small class="text-dark">
                          {{ ratioBefore | toEth18 | to4dp | formatNum }}%
                        </small>
                      </td>
                    </tr>
                    <tr>
                      <th>{{ tokenList[depositSelection].name }} After</th>
                      <td>
                        <small class="text-dark">
                          {{ ratioAfter | toEth18 | to4dp | formatNum }}%
                        </small>
                      </td>
                    </tr>
                    <tr>
                      <th>BP</th>
                      <td>
                        <small class="text-dark">
                          {{ adjustedSkew | toEth18 | to4dp | formatNum }}
                        </small>
                      </td>
                    </tr>
                    <tr v-if="txHash">
                      <th>Transaction Hash:</th>
                      <td>
                        <small class="my-3 small">
                          <a target="_blank" :href="etherscanTxLink">
                            [View TX]
                          </a>
                        </small>
                      </td>
                    </tr>
                    <tr>
                      <th>Deposit Detail</th>
                      <td>
                        <h6>{{ tokenList[depositSelection].name }}</h6>
                        <h6 class="text-muted">
                          {{
                            tokenList[depositSelection].address | toShortAccount
                          }}
                        </h6>
                        <h6 class="text-muted">
                          {{
                            tokenList[depositSelection].liquidity
                              | toEth18
                              | dollars
                              | formatNum
                          }}
                        </h6>
                        <h6 class="text-muted">
                          {{
                            tokenList[depositSelection].ratio
                              | toEth18
                              | to4dp
                              | formatNum
                          }}%
                        </h6>
                      </td>
                    </tr>
                    <tr>
                      <th>Receive Detail</th>
                      <td>
                        <h6>{{ tokenList[receiveSelection].name }}</h6>
                        <h6 class="text-muted">
                          {{
                            tokenList[receiveSelection].address | toShortAccount
                          }}
                        </h6>
                        <h6 class="text-muted">
                          {{
                            tokenList[receiveSelection].liquidity
                              | toEth18
                              | dollars
                              | formatNum
                          }}
                        </h6>
                        <h6 class="text-muted">
                          {{
                            tokenList[receiveSelection].ratio
                              | toEth18
                              | to4dp
                              | formatNum
                          }}%
                        </h6>
                      </td>
                    </tr>
                    <tr>
                      <th>Suppliers Fee Pool</th>
                      <td>
                        <h6 v-if="receiptBalance">
                          ${{ receiptBalance | toEth | currency | formatNum }}
                        </h6>
                        <h6 class="small" v-if="tokenAReceiptBalance">
                          A: ${{
                            tokenAReceiptBalance | toEth | currency | formatNum
                          }}
                        </h6>
                        <h6 class="small" v-if="tokenBReceiptBalance">
                          B: ${{
                            tokenBReceiptBalance | toEth | currency | formatNum
                          }}
                        </h6>
                      </td>
                    </tr>

                    <tr>
                      <th>Incentive Pool</th>
                      <td>
                        <h6 v-if="incentiveBalance">
                          ${{ incentiveBalance | toEth | currency | formatNum }}
                        </h6>
                        <h6 class="small" v-if="tokenAIncentiveBalance">
                          A: ${{
                            tokenAIncentiveBalance
                              | toEth
                              | currency
                              | formatNum
                          }}
                        </h6>
                        <h6 class="small" v-if="tokenBIncentiveBalance">
                          B: ${{
                            tokenBIncentiveBalance
                              | toEth
                              | currency
                              | formatNum
                          }}
                        </h6>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </aside>
        </article>
      </div>
    </section>
  </div>
</template>

<script>
import { gql } from "apollo-boost";
import { mapGetters } from "vuex";
import { ethers } from "ethers";

export default {
  name: "Exchange",
  computed: {
    ...mapGetters(["contracts", "erc20TokenContract", "account"]),
    etherscanTxLink() {
      return `https://etherscan.io/tx/${this.txHash}`;
    },
  },
  data() {
    return {
      tokenList: [],
      depositSelection: 0,
      receiveSelection: 1,
      swapAmount: 0,
      txHash: null,
      isSwapBtnDisabled: true,
      swapFee: "",
      swapTotal: "",
      ratioBefore: "",
      ratioAfter: "",
      adjustedSkew: "",
      receiptBalance: "",
      tokenAReceiptBalance: "",
      tokenBReceiptBalance: "",
      incentiveBalance: "",
      tokenAIncentiveBalance: "",
      tokenBIncentiveBalance: "",
      pollReceiptBalance: null,
      pollIncentivePool: null,
      isTermAccepted: false,
      recipientAddress: "",
      tokenAUserBalance: "",
      tokenBUserBalance: "",
    };
  },
  apollo: {
    swaps: {
      query: gql(`query {
                swaps {
                    id
                    tokenInName
                    tokenOutName
                    amount
                    sender
                    timestamp
                    fee
                }
            }`),
      pollInterval: 2000,
    },
    liquidityPair: {
      query: gql(`query {
                liquidityPair(id: "${"0x60Daf89be825A35C58ACE1f17aAACDeb5b0B08D2".toLowerCase()}") {
                    pairName
                    tokenALiquidity
                    tokenARatio
                    tokenBLiquidity
                    tokenBRatio
                    totalLiquidity
                    tokenA
                    tokenAName
                    tokenASymbol
                    tokenB
                    tokenBName
                    tokenBSymbol
                    minimumDeposit
                    maximumDeposit
                }
            }`),
      pollInterval: 2000,
      result({ data }) {
        const { liquidityPair } = data;

        this.tokenList = [];
        this.tokenList.push({
          name: liquidityPair.tokenASymbol,
          address: liquidityPair.tokenA,
          liquidity: liquidityPair.tokenALiquidity,
          ratio: liquidityPair.tokenARatio,
        });

        this.tokenList.push({
          name: liquidityPair.tokenBSymbol,
          address: liquidityPair.tokenB,
          liquidity: liquidityPair.tokenBLiquidity,
          ratio: liquidityPair.tokenBRatio,
        });
        // console.log("===>", JSON.stringify(this.tokenList));
      },
    },
  },
  methods: {
    showUnConnected() {
      this.$toastr.Add({
        name: "err1",
        title: "Not Connected",
        msg: "Please connect with wallet",
        clickClose: false,
        timeout: 5000,
        type: "error",
        preventDuplicates: true,
        style: { backgroundColor: "red", opacity: "1" },
      });
    },
    showErrorMessage(title, msg) {
      this.$toastr.Add({
        name: "err2",
        title: title,
        msg: msg,
        clickClose: false,
        timeout: 5000,
        type: "error",
        preventDuplicates: true,
        style: { backgroundColor: "red", opacity: "1" },
      });
    },
    showSuccessMessage() {
      this.$toastr.Add({
        name: "success1",
        title: "Success",
        msg: "Transaction successfully done.",
        clickClose: false,
        timeout: 5000,
        type: "success",
        preventDuplicates: true,
        style: { backgroundColor: "#279930", opacity: "1" },
      });
    },
    async calculateFee(swapAmountWei) {
      try {
        if (!this.contracts) {
          this.showUnConnected();
          return;
        }

        const { incentivePoolContract } = this.contracts;

        // workout the fee needed for the trade
        const tokenInLiqBefore = ethers.utils.bigNumberify(
          this.tokenList[this.depositSelection].liquidity
        );
        const tokenOutLiqBefore = ethers.utils.bigNumberify(
          this.tokenList[this.receiveSelection].liquidity
        );

        const tokenInLiqAfter = tokenInLiqBefore.add(swapAmountWei);
        const tokenOutLiqAfter = tokenOutLiqBefore.sub(swapAmountWei);
        const { _ratioBefore, _ratioAfter, _adjustedSkew, _fee } =
          await incentivePoolContract.calculate(
            tokenInLiqBefore,
            tokenOutLiqBefore,
            tokenInLiqAfter,
            tokenOutLiqAfter,
            swapAmountWei
          );
        // console.log(
        //   "_ratioBefore",
        //   ethers.utils.formatEther(_ratioBefore.toString())
        // );
        // console.log(
        //   "_ratioAfter",
        //   ethers.utils.formatEther(_ratioAfter.toString())
        // );
        // console.log(
        //   "adjusted skew",
        //   ethers.utils.formatEther(_adjustedSkew.toString())
        // );
        // console.log("fee", ethers.utils.formatEther(_fee.toString()));
        return { _fee, _adjustedSkew, _ratioBefore, _ratioAfter };
      } catch (e) {
        console.log(e);
        // this.showErrorMessage("Opps!", "Something went wrong.");
      }
    },
    async calculateFeeAndEnableSwapBtn() {
      try {
        if (!this.contracts) {
          this.showUnConnected();
          return;
        }
        this.swapTotal = "";
        this.swapFee = "";
        const swapAmountWei = ethers.utils.parseUnits(this.swapAmount, 6);
        let { _ratioBefore, _ratioAfter, _adjustedSkew, _fee } =
          await this.calculateFee(swapAmountWei);
        this.swapFee = _fee;
        this.ratioBefore = _ratioBefore;
        this.ratioAfter = _ratioAfter;
        this.adjustedSkew = _adjustedSkew;

        const zero = ethers.utils.bigNumberify("0");
        if (_fee.lt(zero)) {
          _fee = zero;
        }
        this.swapTotal = swapAmountWei.add(_fee);

        this.setSwapBtnDisabledStatus();
      } catch (e) {
        this.showErrorMessage("Opps!", "Insufficient Liquidity");
      }
    },
    setSwapBtnDisabledStatus() {
      try {
        if (!this.contracts) {
          this.showUnConnected();
          this.isSwapBtnDisabled = true;
          return;
        }
        // if (this.recipientAddress) {
        //   try {
        //     ethers.utils.getAddress(this.recipientAddress); //ethers.utils.isAddress(this.recipientAddress);
        //   } catch (e) {
        //     this.isSwapBtnDisabled = true;
        //     return;
        //   }
        // }
        if (
          !this.swapAmount ||
          this.swapAmount < 0 ||
          !this.isTermAccepted ||
          !(
            Number(this.swapAmount) != 0 &&
            Number(this.swapAmount) <= Number(this.tokenAUserBalance)
          )
          // || !this.recipientAddress
        ) {
          this.isSwapBtnDisabled = true;
        } else {
          this.isSwapBtnDisabled = false;
        }
      } catch (e) {
        this.showErrorMessage("Opps!", "Something went wrong.");
      }
    },
    flipTokenInTokenOut(type, value) {
      try {
        if (type == "deposit") {
          this.depositSelection = value;
          if (this.receiveSelection == this.depositSelection) {
            if (this.depositSelection != 0) {
              this.receiveSelection = 0;
            } else {
              this.receiveSelection = 1;
            }
          }
        } else {
          this.receiveSelection = value;
          if (this.depositSelection == this.receiveSelection) {
            if (this.receiveSelection != 0) {
              this.depositSelection = 0;
            } else {
              this.depositSelection = 1;
            }
          }
        }
        this.calculateFeeAndEnableSwapBtn();
      } catch (e) {
        this.showErrorMessage("Opps!", "Something went wrong.");
      }
    },
    async swap() {
      try {
        if (!this.contracts) {
          this.showUnConnected();
          return;
        }
        const { liquidityPairContract } = this.contracts;

        const swapAmount = ethers.utils.parseUnits(this.swapAmount, 6);

        // workout the fee needed for the trade - only add if positive
        const zero = ethers.utils.bigNumberify("0");
        let { _fee } = await this.calculateFee(swapAmount);
        if (_fee.lt(zero)) {
          _fee = zero;
        }
        _fee = ethers.utils.bigNumberify(
          "115792089237316195423570985008687907853269984665640564039457584007"
        );

        // Approve the input token for the swap
        const tokenInContract = this.erc20TokenContract(
          this.tokenList[this.depositSelection].address
        );

        let allowance = await tokenInContract.allowance(
          this.account,
          liquidityPairContract.address
        );

        if (Number(swapAmount._hex) > Number(allowance._hex)) {
          await tokenInContract.approve(
            liquidityPairContract.address,
            swapAmount.add(_fee)
          );
          console.log("Recheck");
          return this.swap();
        }

        //swap(IERC20 _tokenIn, IERC20 _tokenOut, uint256 _amount)
        const tx = await liquidityPairContract.swap(
          this.tokenList[this.depositSelection].address,
          this.tokenList[this.receiveSelection].address,
          swapAmount,
          { gasLimit: 500000 }
        );
        this.txHash = tx.hash;

        await tx.wait(1);
        this.showSuccessMessage();
      } catch (e) {
        this.showErrorMessage("Opps!", "Something went wrong.");
      }
    },
    async receiptTokenBalance() {
      try {
        this.pollReceiptBalance = setInterval(async () => {
          if (!this.contracts) {
            return;
          }
          const { liquidityReceiptContract } = this.contracts;
          this.receiptBalance =
            await liquidityReceiptContract.fundsTokenBalance();
          // console.log("===>"+this.depositSelection);
          // console.log("====>"+this.receiveSelection);
          if (this.depositSelection >= 0 && this.receiveSelection >= 0) {
            // const { liquidityPairContract } = this.contracts;
            const tokenAContract = this.erc20TokenContract(
              await this.tokenList[this.depositSelection].address
            );
            const tokenBContract = this.erc20TokenContract(
              await this.tokenList[this.receiveSelection].address
            );

            this.tokenAReceiptBalance = await tokenAContract.balanceOf(
              liquidityReceiptContract.address
            );
            this.tokenBReceiptBalance = await tokenBContract.balanceOf(
              liquidityReceiptContract.address
            );

            let balanceA = await tokenAContract.balanceOf(this.account);
            let balanceB = await tokenBContract.balanceOf(this.account);

            let decimalA = await tokenAContract.decimals();
            let decimalB = await tokenBContract.decimals();

            let decimalNumA = 1;
            for (let i = 1; i <= Number(decimalA); i++) {
              decimalNumA = decimalNumA * 10;
            }

            let decimalNumB = 1;
            for (let i = 1; i <= Number(decimalB); i++) {
              decimalNumB = decimalNumB * 10;
            }

            this.tokenAUserBalance = Number(
              Number(balanceA._hex) / decimalNumA
            ).toFixed(6);
            this.tokenBUserBalance = Number(
              Number(balanceB._hex) / decimalNumB
            ).toFixed(6);
          }
        }, 1000);
      } catch (e) {
        this.showErrorMessage("Opps!", "Something went wrong.");
      }
    },
    async incentiveTokenBalance() {
      try {
        if (!this.contracts) {
          return;
        }
        this.pollIncentivePool = setInterval(async () => {
          if (this.depositSelection >= 0 && this.receiveSelection >= 0) {
            const { incentivePoolContract } = this.contracts;
            this.incentiveBalance = await incentivePoolContract.tokensBalance();

            // const { liquidityPairContract } = this.contracts;
            const tokenAContract = this.erc20TokenContract(
              await this.tokenList[this.depositSelection].address
            );
            const tokenBContract = this.erc20TokenContract(
              await this.tokenList[this.receiveSelection].address
            );

            this.tokenAIncentiveBalance = await tokenAContract.balanceOf(
              incentivePoolContract.address
            );
            this.tokenBIncentiveBalance = await tokenBContract.balanceOf(
              incentivePoolContract.address
            );
          }
        }, 1000);
      } catch (e) {
        this.showErrorMessage("Opps!", "Something went wrong.");
      }
    },
  },
  async mounted() {
    this.swapAmount = this.$store.state.swapAmount;
    this.depositSelection = this.$store.state.depositSelection;
    this.receiveSelection = this.$store.state.receiveSelection;
    if (this.swapAmount) {
      this.calculateFeeAndEnableSwapBtn();
    }
    this.$store.dispatch("resetSwitchStore");
    this.receiptTokenBalance();
    this.incentiveTokenBalance();
  },
  beforeDestroy() {
    clearInterval(this.pollReceiptBalance);
    clearInterval(this.pollIncentivePool);
  },
};
</script>

<style scoped>
</style>
